import { Component } from '@angular/core';

@Component({
  selector: 'cat-page',
  templateUrl: './tabs.html'
})

export class ComponentsTabs {}

